<script setup>
import { Vue3Lottie } from 'vue3-lottie';

import loadingAnimation from '../assets/lottie/loadingAnimation.json';

</script>

<template>
  <div class="page-loader flex flex-col" data-entity="app-pageLoader" data-test="pages-pageLoader">
    <Vue3Lottie :animationData="loadingAnimation" class="page-loader__spinner" />
  </div>
</template>

<style lang="scss" scoped>
.page-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: white;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  color: #333;

  &__spinner {
    width: 25vw;
    height: 25vh;
  }
}

.dark-theme{
  .page-loader {
    background-color: var(--dark-color);
    color: white;
  }
}
</style>
